const licenses = [
  {
    id: 'L1',
    title: 'Лицензия на фармацевтическую деятельность',
    number: '№ЛО42-01158-40/00284248',
    issued: '15.02.2021',
    issuer: 'Министерство здравоохранения Российской Федерации',
    valid: 'Бессрочно',
    color: '#ff2d78',
    icon: 'ri-medal-line',
  },
  {
    id: 'L2',
    title: 'Свидетельство о государственной регистрации',
    number: 'ОГРН 1105321000102',
    issued: '12.03.2010',
    issuer: 'Федеральная налоговая служба России',
    valid: 'Бессрочно',
    color: '#00f5ff',
    icon: 'ri-government-line',
  },
  {
    id: 'L3',
    title: 'Сертификат соответствия ISO 9001:2015',
    number: 'ISO-RU-2023-00847',
    issued: '10.06.2023',
    issuer: 'Bureau Veritas Certification',
    valid: 'До 10.06.2026',
    color: '#39ff14',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'L4',
    title: 'Разрешение на дистанционную торговлю лекарствами',
    number: '№ДТ-77-2021-0034',
    issued: '01.09.2021',
    issuer: 'Росздравнадзор',
    valid: 'Бессрочно',
    color: '#f0ff00',
    icon: 'ri-truck-line',
  },
  {
    id: 'L5',
    title: 'Аккредитация в системе МДЛП',
    number: 'МДЛП-7714844316',
    issued: '01.01.2020',
    issuer: 'ФГИС МДЛП (Честный знак)',
    valid: 'Действующая',
    color: '#ff6b00',
    icon: 'ri-qr-code-line',
  },
  {
    id: 'L6',
    title: 'Членство в Ассоциации аптечных сетей России',
    number: 'РААС-2015-0112',
    issued: '15.04.2015',
    issuer: 'Российская ассоциация аптечных сетей',
    valid: 'Действующее',
    color: '#ff2d78',
    icon: 'ri-group-2-line',
  },
];

const certBadges = [
  { label: 'Честный знак', icon: 'ri-verified-badge-line', color: '#39ff14' },
  { label: 'ЕГИСЗ', icon: 'ri-hospital-line', color: '#00f5ff' },
  { label: 'Росздравнадзор', icon: 'ri-shield-cross-line', color: '#ff2d78' },
  { label: 'ISO 9001', icon: 'ri-award-line', color: '#f0ff00' },
];

const AboutLicenses = () => (
  <section className="px-6 lg:px-12 pb-24">
    <div className="max-w-7xl mx-auto">
      {/* Section header */}
      <div className="mb-14">
        <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan/60 mb-2">ДОКУМЕНТЫ И СЕРТИФИКАТЫ</p>
        <h2 className="font-orbitron font-black text-3xl md:text-4xl text-white">
          ЛИЦЕНЗИИ И<br />
          <span style={{ color: '#39ff14', textShadow: '0 0 20px #39ff1460' }}>АККРЕДИТАЦИИ</span>
        </h2>
        <div className="mt-3 w-16 h-0.5" style={{ background: 'linear-gradient(90deg, #39ff14, transparent)' }} />
      </div>

      {/* Cert badges */}
      <div className="flex flex-wrap gap-3 mb-10">
        {certBadges.map((b) => (
          <div
            key={b.label}
            className="flex items-center gap-2 px-4 py-2 rounded-full"
            style={{ background: `${b.color}10`, border: `1px solid ${b.color}30` }}
          >
            <i className={`${b.icon} text-sm`} style={{ color: b.color }} />
            <span className="font-mono text-xs" style={{ color: b.color }}>{b.label}</span>
          </div>
        ))}
      </div>

      {/* License cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {licenses.map((lic) => (
          <div
            key={lic.id}
            className="card-cyber rounded-2xl p-6 group transition-all duration-300 relative overflow-hidden"
            style={{ borderColor: `${lic.color}20` }}
          >
            {/* Top accent */}
            <div
              className="absolute top-0 left-0 right-0 h-0.5"
              style={{ background: `linear-gradient(90deg, transparent, ${lic.color}60, transparent)` }}
            />

            <div className="flex items-start gap-4 mb-4">
              <div
                className="w-11 h-11 flex items-center justify-center rounded-xl shrink-0"
                style={{ background: `${lic.color}15`, border: `1px solid ${lic.color}40` }}
              >
                <i className={`${lic.icon} text-xl`} style={{ color: lic.color }} />
              </div>
              <div>
                <h3 className="font-orbitron font-bold text-xs text-white leading-snug mb-1">{lic.title}</h3>
                <span
                  className="font-mono text-xs font-bold"
                  style={{ color: lic.color, textShadow: `0 0 8px ${lic.color}50` }}
                >
                  {lic.number}
                </span>
              </div>
            </div>

            <div className="space-y-2 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
              <div className="flex justify-between items-center">
                <span className="font-mono text-xs text-white/30">Выдана</span>
                <span className="font-mono text-xs text-white/60">{lic.issued}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-mono text-xs text-white/30">Орган</span>
                <span className="font-mono text-xs text-white/50 text-right max-w-[60%] leading-tight">{lic.issuer}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-mono text-xs text-white/30">Срок действия</span>
                <span
                  className="font-mono text-xs font-bold"
                  style={{ color: lic.color }}
                >
                  {lic.valid}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Disclaimer */}
      <div
        className="mt-8 p-5 rounded-2xl"
        style={{ background: 'rgba(0,245,255,0.04)', border: '1px solid rgba(0,245,255,0.12)' }}
      >
        <div className="flex items-start gap-3">
          <i className="ri-information-line text-base mt-0.5 shrink-0" style={{ color: '#00f5ff' }} />
          <p className="font-mono text-xs text-white/40 leading-relaxed">
            Все лекарственные препараты, реализуемые в аптеках Горздрав, прошли государственную регистрацию
            и соответствуют требованиям Федерального закона № 61-ФЗ «Об обращении лекарственных средств».
            Копии лицензий доступны по запросу в любой аптеке сети.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default AboutLicenses;
